<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup>
import logger from "debug";
import "./assets/styles/index.scss";
import "./assets/styles/animation.scss";
import { useMiraStore } from "./store/mira";
import { useViewerStore } from "./store/viewer";
//variables

const debug = logger("travvir:app.vue");
const isPortrait = ref(null);
const miraStore = useMiraStore();
const { $busSocket } = useNuxtApp();
const viewerStore = useViewerStore();
const headers = useRequestHeaders(["referer"]);
//provide
provide("isPortrait", isPortrait);

//methods
const updateOrientation = () => {
  if (miraStore.inputInFocus) return;
  isPortrait.value = window.innerHeight > window.innerWidth;
  viewerStore.isPortrait = isPortrait.value;
};

function checkServerOrientation() {
  if (process.client) return;
  const headers = useRequestHeaders();
  const userAgent = headers["user-agent"] || "";
  const isMobile =
    /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  isPortrait.value = isMobile ? true : false;
  viewerStore.isPortrait = isPortrait.value;
}

// set referer cookie
if (process.server) {
  checkServerOrientation();
  const referer = headers.referer || "";
  const prevReferer = useCookie("visitor_referer");
  if (
    referer &&
    (!prevReferer.value || prevReferer.value.includes("travvir.com"))
  ) {
    const refererCookie = useCookie("visitor_referer", {
      maxAge: 15 * 60,
      path: "/",
    });
    refererCookie.value = referer;
  }
}

if (process.client) {
  let busSocket = $busSocket.open();
  provide("busSocket", busSocket);
}

onMounted(() => {
  debug("App mounted");
  updateOrientation();
  const wrapper = document.getElementById("wrapper");
  if (wrapper) {
    if (isPortrait.value) {
      wrapper.classList.add("isMobile");
    } else {
      wrapper.classList.remove("isMobile");
    }
  }
  window.addEventListener("resize", updateOrientation);
  window.addEventListener("orientationchange", () => {
    miraStore.inputInFocus = false;
    updateOrientation();
  });
});
onUnmounted(() => {
  window.removeEventListener("resize", updateOrientation);
  window.removeEventListener("orientationchange", updateOrientation);
});
</script>

<style lang="scss"></style>
